import { render, staticRenderFns } from "./PayFor.vue?vue&type=template&id=1fa23ab0&"
import script from "./PayFor.vue?vue&type=script&lang=js&"
export * from "./PayFor.vue?vue&type=script&lang=js&"
import style0 from "./PayFor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports